import React from "react";
import { Box, Typography } from "@mui/material";
import { DashboardChartsDateProvider } from "./context/dashboardChartsDateContext";
import { useDashboardChartTabs } from "./hooks/useDashboardChartTabs";
import { DashboardChartsView } from "./components/DashboardChartsView";
import { DASHBOARD_PAGE_BG } from "./dashboardChartStyles";

function GraficiChartsContent() {
  const tabs = useDashboardChartTabs();

  if (tabs.charts.length === 0) {
    return (
      <Box sx={{ py: 2, bgcolor: DASHBOARD_PAGE_BG }}>
        <Typography sx={{ fontFamily: "Rubik", color: "#64748b", fontSize: 14 }}>
          Nessun grafico abilitato in configurazione.
        </Typography>
      </Box>
    );
  }

  return <DashboardChartsView {...tabs} />;
}

const GraficiDashboard = () => (
  <DashboardChartsDateProvider>
    <GraficiChartsContent />
  </DashboardChartsDateProvider>
);

export default GraficiDashboard;
